import { ref } from "vue";

// Server capability only; deliberately independent of the inherited flag model.
export const customerTicketsEnabled = ref(false);
let accessRun = 0;
export function setCustomerTicketsEnabled(value: boolean) {
  ++accessRun;
  customerTicketsEnabled.value = value;
}
export async function refreshCustomerTicketsAccess(
  token: string | null | undefined,
) {
  const run = ++accessRun;
  customerTicketsEnabled.value = false;
  if (!token) return;
  try {
    const response = await fetch("/backend/customer-tickets/access", {
      headers: { Authorization: `Bearer ${token}` },
      cache: "no-store",
    });
    const result = response.ok ? await response.json() : null;
    if (run === accessRun)
      customerTicketsEnabled.value = result?.enabled === true;
  } catch {
    /* Unavailable capability fails closed without blocking other pages. */
  }
}
